import { FDealType, FOfferType, isAvailable } from '../../../../JsonQuery';
import { PriceContainer } from '../../containers/filters/PriceContainer';
import { IFilter } from '../../types/filters';

export const price: IFilter = {
  availability: isAvailable(FDealType.Any, FOfferType.Any),
  component: PriceContainer,
};
